/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { InputSwitch } from 'primereact/inputswitch';
import { TabMenu } from 'primereact/tabmenu';
import { Divider } from 'primereact/divider';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';

import FileInput from '@components/FileInput';
import ModalPreview from '@components/Section/ModalPreview';

import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';

import store from '@store';

class BannerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      backgroundImg: [],
      hasBnt: true,
      btnHref: '',
      btnTarget: '_blank',
      loadingPage: true,
      languagePreview: [],
      errors: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: '',
      },
    };

    this.initialValuesForm = {
      title: '',
      btnText: '',
      description: ''
    };
  }

  componentDidMount() {
    const { keysLenguages, _banner, itemsTabsLenguages, t } = this.props;
    if (_banner) {
      this.setState({
        ..._banner,
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      let label =
        t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '');
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`);
        },
      };
    });
    this.setState({ languagePreview });
    this.setState({ loadingPage: false });
  }

  uploadFile = (files, isImage) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    this.setState({ backgroundImg: [data] }, () => this.validateFieldsOnchange('backgroundImg', data));
  };

  removeFile = () => {
    this.setState({ backgroundImg: [] });
  };

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeEditor = (names, e) => {
    const [language, name] = names.split('-');

    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: e.textValue },
    }), () => this.validateFieldsOnchange(names, e.textValue));
  };

  onChangeSimple = ({ target }) => {
    this.setState(
      { [target.name]: target.value },
      () => this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { hasBnt, btnHref, backgroundImg } = this.state
    const { btnText, description, title } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!title) errors = { ...errors, [`${LANGUAGE_DEFAULT}-title`]: 'Titulo es requerido'}
    if (!description) errors = { ...errors, [`${LANGUAGE_DEFAULT}-description`]: 'Descripción es requerido'}
    if (!backgroundImg.length) errors = { ...errors, [`backgroundImg`]: 'Imagen es requerido'}
    if (hasBnt) {
      if (!btnHref) errors = { ...errors, [`btnHref`]: 'Link es requerido' }
      if (!btnText) errors = { ...errors, [`${LANGUAGE_DEFAULT}-btnText`]: 'Texto Botón es requerido'}
    }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    let validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props;
    await this.setValuesToStateGlobal();
    success();
  };

  setValuesToStateGlobal = async () => {
    const { backgroundImg, hasBnt, btnHref, btnTarget } = this.state;
    const { keysLenguages } = this.props;
    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});

    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: {
        banner: { ...getValues, backgroundImg, hasBnt, btnHref, btnTarget },
      },
    });
  };

  onPreview = async (language) => {
    // const { keysLenguages } = this.props
    // const { activeTabIndex } = this.state;
    await this.setValuesToStateGlobal();
    // const language = keysLenguages[activeTabIndex];

    return this.setState({
      showModalPreview: {
        visible: true,
        language,
      },
    });
  };

  onHideModalPreview = () => {
    this.setState({ showModalPreview: { visible: false } });
  };

  render() {
    const {
      t,
      btnSubmitLoading,
      itemsTabsLenguages,
      keysLenguages,
      onBack
    } = this.props;
    const {
      activeTabIndex,
      loadingPage,
      backgroundImg,
      showModalPreview,
      languagePreview,
      hasBnt,
      btnHref,
      btnTarget,
      errors
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Titulo', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-title`}
              type="text"
              value={this.state[prefixLenguage].title}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-title`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-title`)}
          </div>
          <div className="p-col-12">
            <div className="p-field">
              <label className="p-text-bold">{t('Texto Botón', {lng: prefixLenguage })}</label>
              <InputText
                name={`${prefixLenguage}-btnText`}
                type="text"
                value={this.state[prefixLenguage].btnText}
                onChange={this.onChange}
                disabled={!hasBnt}
                className={classNames({
                  'p-invalid': isFormFieldValid(`${prefixLenguage}-btnText`),
                })}
              />
              {getFormErrorMessage(`${prefixLenguage}-btnText`)}
            </div>
          </div>
          <div className="p-col-12 p-field">
            <label htmlFor="description" className="p-text-bold">
              {t('Descripción', {lng: prefixLenguage })}
            </label>
            <Editor
              name={`${prefixLenguage}-description`}
              style={{ height: '200px' }}
              value={this.state[prefixLenguage].description}
              onTextChange={(e) =>
                this.onChangeEditor(`${prefixLenguage}-description`, e)
              }
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-description`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-description`)}
          </div>
        </>
      );
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) =>
                    this.setState({ activeTabIndex: e.index })
                  }
                />
              )}
            </div>
            {renderByTabLenguage()}
            <div className="p-divider p-component p-divider-horizontal p-divider-dashed p-d-flex p-jc-between" role="separator">
              <div className="p-divider-content">
                <b>{t('Opciones de Botón')}</b>
              </div>
              <div className="p-divider-content">
                <InputSwitch
                  name="hasBnt"
                  checked={this.state.hasBnt}
                  onChange={this.onChangeSimple}
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6 p-lg-6">
              <div className="p-field">
                <label className="p-text-bold">{t('Link')}</label>
                <span className="p-input-icon-left">
                  <i className="pi pi-globe" />
                  <InputText
                    name="btnHref"
                    value={btnHref}
                    onChange={this.onChangeSimple}
                    disabled={!hasBnt}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`btnHref`),
                    })}
                  />
                </span>
                {getFormErrorMessage(`btnHref`)}
              </div>
            </div>
            <div className="p-col-12 p-md-6 p-lg-6">
              <label className="p-text-bold">{t('Abrir en')}</label>
              <div className="p-field-radiobutton p-mt-2">
                <RadioButton
                  inputId="btnTarget1"
                  name="btnTarget"
                  value="_blank"
                  onChange={this.onChangeSimple}
                  checked={btnTarget === '_blank'}
                  disabled={!hasBnt}
                />
                <label className="p-pr-3" htmlFor="btnTarget1">{t('Nueva ventana')}</label>
                <RadioButton
                  inputId="btnTarget2"
                  name="btnTarget"
                  value="_self"
                  onChange={this.onChangeSimple}
                  checked={btnTarget === '_self'}
                  disabled={!hasBnt}
                />
                <label htmlFor="btnTarget2">{t('Ventana actual')}</label>
              </div>
              {/* <div className="p-field-radiobutton">
              </div> */}
            </div>
            <Divider align="left" type="dashed">
              <b>{t('Imagen')}</b>
            </Divider>
            <div className="p-col-12 p-md-6 p-lg-6">
              <FileInput
                onChangeFile={this.uploadFile}
                files={backgroundImg}
                removeAllFiles={this.removeFile}
                removeFile={this.removeFile}
                accept="/image*"
                txtDrop={t('Arrastra y suelta el archivo')}
                classNameBorderMain={classNames({
                  'p-invalid': isFormFieldValid('backgroundImg'),
                })}
              />
              {getFormErrorMessage(`backgroundImg`)}
            </div>
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Cancelar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-info"
                // style={{ width: '150px' }}
                model={languagePreview}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          {showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _banner: state.section.banner,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  layoutsHtml: state.section.layoutsHtml,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(BannerForm);
